import { render } from "./App.vue?vue&type=template&id=98f93ce8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=98f93ce8&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__